import React from 'react';
import { FaFilePdf, FaPlayCircle } from 'react-icons/fa';
// Monta a faixa "Abrir PDF" | "Assistir vídeo" com o mesmo comportamento de hoje:
// o PDF abre o link em nova aba e o vídeo abre o player.
export var montarAcoesMateriais = function (_a) {
    var pdfUrl = _a.pdfUrl, _b = _a.rotuloPdf, rotuloPdf = _b === void 0 ? 'Abrir PDF' : _b, onAssistirVideo = _a.onAssistirVideo;
    var acoes = [];
    if (pdfUrl) {
        acoes.push({ label: rotuloPdf, icon: React.createElement(FaFilePdf, null), href: pdfUrl });
    }
    if (onAssistirVideo) {
        acoes.push({ label: 'Assistir vídeo', icon: React.createElement(FaPlayCircle, null), onClick: onAssistirVideo });
    }
    return acoes;
};
